import React, { PureComponent } from 'react';
import Sortable from 'react-sortablejs';
import style from './styles/style.module.css';

export default class TableBody extends PureComponent {
    render() {
        const { children } = this.props;
        const className = `dl-table-body sortable ${ style.tableBody } ${ this.props.className }`;

        return (
            <Sortable className={ className }
            onChange={ this.props.onChange }
            tag='div' handle={ this.props.handle }>
                { children }
            </Sortable>
        );
    }
}
TableBody.defaultProps = {
    className: '',
    handle: '.handle',
    onChange: () => {},
};
